/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const propertyTrackingStatusEnum = {
    "ESTIMATION_PENDING": "ESTIMATION_PENDING",
    "ESTIMATION_VALIDATED": "ESTIMATION_VALIDATED",
    "ESTIMATION_REFUSED": "ESTIMATION_REFUSED",
    "MANDATE_PENDING_SIGNATURE": "MANDATE_PENDING_SIGNATURE",
    "MANDATE_SIGNED": "MANDATE_SIGNED",
    "MANDATE_REFUSED": "MANDATE_REFUSED",
    "OFFER_NONE": "OFFER_NONE",
    "OFFER_SUBMITTED": "OFFER_SUBMITTED",
    "OFFER_VALIDATED": "OFFER_VALIDATED",
    "OFFER_REFUSED": "OFFER_REFUSED",
    "APPLICATION_NONE": "APPLICATION_NONE",
    "APPLICATION_SUBMITTED": "APPLICATION_SUBMITTED",
    "APPLICATION_VALIDATED": "APPLICATION_VALIDATED",
    "APPLICATION_REFUSED": "APPLICATION_REFUSED",
    "AGREEMENT_IN_PROGRESS": "AGREEMENT_IN_PROGRESS",
    "AGREEMENT_VALIDATED": "AGREEMENT_VALIDATED",
    "AGREEMENT_SUSPENDED": "AGREEMENT_SUSPENDED",
    "DEED_IN_PROGRESS": "DEED_IN_PROGRESS",
    "DEED_VALIDATED": "DEED_VALIDATED",
    "DEED_CANCELLED": "DEED_CANCELLED",
    "LEASE_IN_PROGRESS": "LEASE_IN_PROGRESS",
    "LEASE_VALIDATED": "LEASE_VALIDATED",
    "LEASE_SUSPENDED": "LEASE_SUSPENDED",
    "SOLD": "SOLD",
    "AGREEMENT_CANCELLED": "AGREEMENT_CANCELLED",
    "SALE_CANCELLED": "SALE_CANCELLED",
    "RENTED": "RENTED",
    "WITHDRAWN": "WITHDRAWN"
} as const;

export type PropertyTrackingStatusEnum = (typeof propertyTrackingStatusEnum)[keyof typeof propertyTrackingStatusEnum];

/**
 * @description Statut de suivi d\'un bien, sous-statut de sa phase (Règles métiers : Cycle de vie & statut de suivi).\nCertains statuts n\'ont de sens qu\'en vente (offre, compromis, acte notarié) ou qu\'en location\n(dossier, bail) ; le viager et la vente aux enchères suivent le parcours de la vente.\n\nBrouillon (vente et location) :\n- ESTIMATION_PENDING : Estimation en attente (statut initial)\n- ESTIMATION_VALIDATED : Estimation validée\n- ESTIMATION_REFUSED : Estimation refusée ou annulée\n- MANDATE_PENDING_SIGNATURE : Mandat en attente de signature\n- MANDATE_SIGNED : Mandat signé\n- MANDATE_REFUSED : Mandat refusé ou annulé\n\nActif :\n- OFFER_NONE : Sans offre (vente)\n- OFFER_SUBMITTED : Offre déposée (vente)\n- OFFER_VALIDATED : Offre validée (vente)\n- OFFER_REFUSED : Offre refusée ou annulée (vente)\n- APPLICATION_NONE : Sans dossier (location)\n- APPLICATION_SUBMITTED : Dossier déposé (location)\n- APPLICATION_VALIDATED : Dossier validé (location)\n- APPLICATION_REFUSED : Dossier refusé ou annulé (location)\n\nFinalisation :\n- AGREEMENT_IN_PROGRESS : Compromis en cours (vente)\n- AGREEMENT_VALIDATED : Compromis validé (vente)\n- AGREEMENT_SUSPENDED : Compromis suspendu ou annulé (vente)\n- DEED_IN_PROGRESS : Acte notarié en cours (vente)\n- DEED_VALIDATED : Acte notarié validé (vente)\n- DEED_CANCELLED : Acte notarié annulé (vente)\n- LEASE_IN_PROGRESS : Bail en cours (location)\n- LEASE_VALIDATED : Bail validé (location)\n- LEASE_SUSPENDED : Bail suspendu ou annulé (location)\n\nArchivé :\n- SOLD : Vendu (vente)\n- AGREEMENT_CANCELLED : Compromis annulé (vente)\n- SALE_CANCELLED : Vente annulée (vente)\n- RENTED : Loué (location)\n- WITHDRAWN : Bien retiré ou annulé (vente et location)\n
 * @example OFFER_SUBMITTED
*/
export type PropertyTrackingStatus = PropertyTrackingStatusEnum;